import BaseResource from './index'
import UserResource from './user'
import EntitiesResource from './entities'
import validators from '../utilities/validation'

function validateUserId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'User Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateEntityId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Entity Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateApproverGroup(value, instance, ValidationError) {
    try {
        if (instance.attributes.approver_type !== '3') {
            validators.isNonEmpty(value, instance, ValidationError)
        }
    } catch (validationError) {
        validationError.field = 'Approver Group'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateApproverType(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Approver Type'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateFinalApprover(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Final Approver'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateSendNotifications(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
        validators.isZeroOrOne(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Send Notifications'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateStatus(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
        validators.isZeroOrOne(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Status'
        throw validationError + '(' + validationError.field + ')'
    }
}

export default class ApproverResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/approvers'

    static related = {
        user_id: UserResource,
        entity_id: EntitiesResource,
    }

    static validation = {
        user_id: validateUserId,
        entity_id: validateEntityId,
        approver_group: validateApproverGroup,
        approver_type: validateApproverType,
        final_approver: validateFinalApprover,
        send_notifications: validateSendNotifications,
        status: validateStatus,
    }
}
